var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showActualLocation)?_c('div',{staticStyle:{"line-height":"20px"}},[_vm._v("\n    "+_vm._s(_vm.locationFullName)+" "),_c('br'),_c('small',[_vm._v(_vm._s(_vm.$t('Actual'))+" - "+_vm._s(_vm.locationCode))])]):_c('div',[_vm._v("\n    "+_vm._s(_vm.locationFullName)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }